<div class="wrapper">

  <div class="statuses-container">
    <div class="status-box" matTooltip="Se utiliza el algoritmo FIFO para realizar el cálculo"> <!--[ngStyle]="statusOn(status.id) ? {'border': '1px solid ' + status.color} : {}"-->
      <div class="status-content">
        <div class="checkbox-container">
          <mat-icon class="default">dollar</mat-icon>
          <mat-icon class="on-hover">dollar</mat-icon>
        </div>
        <div class="counter">
          <span class="default">{{ availableInventoryCost | money }}</span>
          <span class="on-hover">{{ availableInventoryCost | money }}</span>
        </div>
        <div class="status-name">
          Costo de Inventario Disponible
        </div>
      </div>
    </div>
  </div>

  <div class="filter-button-container">
    <button
      mat-icon-button
      class="primary"
      (click)="showFilters.set(!showFilters())"
      [matTooltip]="showFilters() ? 'Ocultar Filtros' : 'Mostrar Filtros'"
    >
      <mat-icon style="color: var(--mat-sys-on-primary);">filter_list</mat-icon>
    </button>
  </div>

  @if (showFilters()) {
    <form [formGroup]="filters" class="filters form-row">
      <mat-form-field appearance="outline">
        <mat-label>Por SKU</mat-label>
        <input matInput formControlName="code" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Por Nombre</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field appearance="outline"> 
        <mat-label>Fecha Hasta</mat-label>
        <input matInput [matDatepicker]="to_date" formControlName="to_date">
        <mat-datepicker-toggle matSuffix [for]="to_date"></mat-datepicker-toggle>
        <mat-datepicker #to_date></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline"> 
        <mat-label>Bodega</mat-label>
        <mat-select matInput formControlName="warehouse_id">
          <mat-option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
            {{ warehouse.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  }

  <div class="table-container display-desktop">
    <mat-card class="box-shadowless">
      <mat-card-content style="padding: 0;">
          <mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">
            <ng-container matColumnDef="code">
              <mat-header-cell *matHeaderCellDef mat-sort-header> SKU </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.product.code }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.product.name }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="stock_on_hand">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Stock En Mano </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span>
                  {{ element.stock_on_hand }}
                </span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="committed_stock">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Stock Reservado </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span>
                  {{ element.committed_stock }}
                </span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="available_for_sale">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Disponible para venta </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span>
                  {{ element.available_for_sale }}
                </span>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goToProductDetails(row)" [style]="{ cursor: 'pointer' }"></mat-row>
          </mat-table>

        <mat-progress-bar mode="indeterminate" *ngIf="isLoading()"></mat-progress-bar>
        <mat-paginator
          #paginator
          [length]="totalData"
          [pageSizeOptions]="pageSizes"
          showFirstLastButtons
        ></mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="table-container display-mobile scroll-shadows" id="products" appPagination (loadMore)="getMore()" [isLoading]="isLoading()" [page]="page" [totalPages]="totalPages">
    @for (product of dataSource.data; track product.product.code) {
      <div class="card" (click)="goToProductDetails(product)" [style]="{ cursor: 'pointer' }">
        <div class="card-content">
          <div class="card-details">
            <div>
              <div class="row title">
                <span class="bold">{{ product.product.name | human }}</span>
              </div>
              <div class="row">
                <span class="light">#{{ product.product.code }}</span>
              </div>
            </div>
            <div class="row">
              <span>Stock En Mano: {{product.stock_on_hand}}</span>
            </div>
            <div class="row">
              <span>Stock Reservado: {{product.committed_stock}}</span>
            </div>
            <div class="row">
              <span>Disponible para venta: {{product.available_for_sale}}</span>
            </div>
          </div>
        </div>
      </div>
    }


    @if (dataSource && !isLoading() && totalData === 0) {
      <div class="empty">
        <span>No se han encontrado items</span>
      </div>
    }

    @if (isLoading()) {
      <div class="load-more" id="load-more">
        <mat-spinner [diameter]="20"></mat-spinner> Cargando items...
      </div>
    }
  </div>
</div>
